import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../../../router/Routes';
import { LoadingWidget } from '../../../../../widgets';
import ContainerTemplate from '../../../../../widgets/template/Container';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { allEstudiantesNotasEvaluativasAction } from '../../../estudiantes/EstudiantesAction';
import DetallesPlanEvaluacionComponent from './components/DetallesPlanEvaluacion';

const PanelPlanEvaluacionModule = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const estudiantesStore = Redux.useSelector((state) => state.estudiantes);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );

  const admin = [ROUTES.controlEstudios, ROUTES.planEvaluacion];

  const teacher = [ROUTES.planEvaluacion];

  return (
    <ContainerTemplate
      active={ROUTES.panelPlanEvaluacion}
      routes={loginStore.isAdmin ? admin : teacher}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Stack direction="row" alignItems="center">
            <BotonComponent
              click={() => {
                allEstudiantesNotasEvaluativasAction(dispatch, {
                  idEntidad: entidadesStore.activo.id,
                  idPeriodoAcademico:
                    planEvaluacionStore.activo.fechaBloque.periodoAcademico.id,
                  idPlanEvaluacion: planEvaluacionStore.activo.id,
                });
              }}
              text="ACTUALIZAR NOTAS DE ESTUDIANTES"
              white
              mr={2}
              refreshIcon
            />
            {/* <BotonComponent
              text="EXPORTAR PDF"
              // click={() => setOpenModalReporte(!openModalReporte)}
              red
              downloadIcon
              mr={2}
            /> */}
          </Stack>
        </Grid>
        <Grid item xs={12} md={12}>
          <LoadingWidget isLoading={estudiantesStore.loadingAll} />
          <DetallesPlanEvaluacionComponent />
        </Grid>
      </Grid>
    </ContainerTemplate>
  );
};

export default PanelPlanEvaluacionModule;
